import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-alternatives';

export default function Example() {
  return (
    <>
      <Head>
        <title>Beyond Poshmark - 7 Online Marketplaces For Your Pre-loved Clothes and Items</title>
        <meta
          name='description'
          content='Expand your reseller business to new customers and hit new heights by selling to these marketplaces!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-alternatives' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-alternatives' />
        <meta
          property='og:title'
          content='Beyond Poshmark - 7 Online Marketplaces For Your Pre-loved Clothes and Items'
        />
        <meta
          property='og:description'
          content='Expand your reseller business to new customers and hit new heights by selling to these marketplaces!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-09-21T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-09-21T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
